
// Inject qty input CSS once
if (!window.QUOTE_QTY_CSS_INJECTED) {
  window.QUOTE_QTY_CSS_INJECTED = true;
  var _s = document.createElement('style');
  _s.textContent = '.quote-qty-input::-webkit-outer-spin-button,.quote-qty-input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}.quote-qty-input{width:70px !important;height:32px !important;text-align:center !important;padding:4px 0 !important;margin:0 4px !important;border:1px solid #ccc !important;border-radius:4px !important;font-size:14px !important;line-height:24px !important;font-weight:600 !important;color:#222 !important;-moz-appearance:textfield;appearance:textfield;box-sizing:border-box !important;vertical-align:middle !important;min-width:70px !important;background:#fff !important;}.quote-qty-input:focus{outline:none !important;border-color:#2a9d8f !important;}';
  document.head.appendChild(_s);
}
/* ==========================================================================
   CoThings â€” Request Quote Feature (Demander un Devis)
   Uses localStorage + Odoo API for direct quotation creation
   ========================================================================== */

// ---- Odoo Quote API Configuration ----
var ODOO_QUOTE_CONFIG = {
  url: 'https://erpnew.cothings.net/shopify/quote/request/1',
  apiKey: 'uCqan_GintIonBvs69ElaIP88SC4t6Q-TopahU3cimoXVNfGUUHaFam-aP3iSyYJ'
};

window.QuoteManager = (function() {
  var STORAGE_KEY = 'cothings_quote_items';

  // ---- LocalStorage CRUD ----
  function getItems() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch(e) { return []; }
  }
  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function addItem(data) {
    var items = getItems();
    var existing = items.find(function(i) { return i.variant_id == data.variant_id; });
    if (existing) {
      existing.quantity += data.quantity || 1;
    } else {
      items.push({
        product_id: data.product_id,
        variant_id: data.variant_id,
        title: data.title,
        variant_title: data.variant_title || '',
        image: data.image,
        url: data.url,
        price: data.price,
        quantity: data.quantity || 1,
        sku: data.sku || ''
      });
    }
    saveItems(items);
    updateBadge();
    showToast(data.title);
  }

  function removeItem(variantId) {
    var items = getItems().filter(function(i) { return i.variant_id != variantId; });
    saveItems(items);
    updateBadge();
    renderDropdown();
  }

  function updateQuantity(variantId, qty) {
    var items = getItems();
    var item = items.find(function(i) { return i.variant_id == variantId; });
    if (item) {
      item.quantity = Math.max(1, parseInt(qty) || 1);
      saveItems(items);
      updateBadge();
      renderDropdown();
    }
  }

  function clearAll() {
    saveItems([]);
    updateBadge();
    renderDropdown();
  }

  function getCount() {
    return getItems().reduce(function(sum, i) { return sum + i.quantity; }, 0);
  }

  // ---- Badge ----
  function updateBadge() {
    var count = getCount();
    var badges = document.querySelectorAll('.quote-badge');
    badges.forEach(function(b) {
      b.textContent = count;
      b.classList.toggle('hidden', count === 0);
    });
  }

  // ---- Toast ----
  function showToast(title) {
    var toast = document.getElementById('quote-toast');
    if (!toast) return;
    toast.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg> <span>Ajout\u00e9 au devis: <b>' + (title.length > 30 ? title.substring(0, 27) + '...' : title) + '</b></span>';
    toast.style.display = 'flex';
    toast.classList.remove('hide');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function() {
      toast.classList.add('hide');
      setTimeout(function() { toast.style.display = 'none'; }, 300);
    }, 3000);
  }

  // ---- Add from Product Page ----
  function addFromProductPage() {
    var btn = document.querySelector('.btn-quote');
    if (!btn) return;

    var variantSelect = document.querySelector('.product-form select[name="id"]');
    var variantInput = document.querySelector('.product-form input[name="id"]');
    var variantId = variantSelect ? variantSelect.value : (variantInput ? variantInput.value : btn.dataset.variantId);
    var qtyInput = document.querySelector('#quantity');
    var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

    var variantTitle = '';
    if (variantSelect) {
      var selected = variantSelect.options[variantSelect.selectedIndex];
      if (selected) variantTitle = selected.text;
    }

    addItem({
      product_id: btn.dataset.productId,
      variant_id: variantId,
      title: btn.dataset.title,
      variant_title: variantTitle,
      image: btn.dataset.image,
      url: btn.dataset.url,
      price: parseInt(btn.dataset.price) || 0,
      quantity: qty,
      sku: btn.dataset.sku || ''
    });
  }

  // ---- Dropdown ----
  function renderDropdown() {
    var dd = document.getElementById('quote-dropdown');
    if (!dd) return;
    var items = getItems();
    var itemsContainer = dd.querySelector('.quote-dd-items');
    var emptyContainer = dd.querySelector('.quote-dd-empty');
    var footerContainer = dd.querySelector('.quote-dd-footer');

    if (items.length === 0) {
      itemsContainer.innerHTML = '';
      itemsContainer.style.display = 'none';
      emptyContainer.style.display = 'block';
      footerContainer.style.display = 'none';
      return;
    }

    emptyContainer.style.display = 'none';
    itemsContainer.style.display = 'block';
    footerContainer.style.display = 'block';

    var html = '';
    items.forEach(function(item) {
      var imgSrc = item.image || '';
      var priceStr = (item.price / 100).toFixed(3).replace('.', ',') + ' DT';
      html += '<div class="quote-dd-item" data-variant="' + item.variant_id + '">';
      html += '<div class="quote-dd-item-img"><img src="' + imgSrc + '" alt=""></div>';
      html += '<div class="quote-dd-item-info">';
      html += '<a href="' + item.url + '" class="quote-dd-item-title">' + item.title + '</a>';
      html += '<div class="quote-dd-item-meta">';
      html += '<span class="quote-dd-item-price">' + priceStr + '</span>';
      html += '<div class="quote-dd-qty-controls">';
      html += '<button onclick="QuoteManager.updateQuantity(\'' + item.variant_id + '\',' + (item.quantity - 1) + ')" class="quote-qty-btn">-</button>';
      html += '<input type="number" min="1" value="' + item.quantity + '" class="quote-qty-input quote-dd-item-qty" onchange="QuoteManager.updateQuantity(\'' + item.variant_id + '\', this.value)" onclick="this.select()" />';
      html += '<button onclick="QuoteManager.updateQuantity(\'' + item.variant_id + '\',' + (item.quantity + 1) + ')" class="quote-qty-btn">+</button>';
      html += '</div>';
      html += '</div></div>';
      html += '<div class="quote-dd-item-actions">';
      html += '<button onclick="QuoteManager.removeItem(\'' + item.variant_id + '\')" title="Supprimer"><svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor"><path d="M5.5 5.5A.5.5 0 016 6v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm2.5 0a.5.5 0 01.5.5v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm3 .5a.5.5 0 00-1 0v6a.5.5 0 001 0z"/><path d="M14.5 3a1 1 0 01-1 1H13v9a2 2 0 01-2 2H5a2 2 0 01-2-2V4h-.5a1 1 0 01-1-1V2a1 1 0 011-1H6a1 1 0 011-1h2a1 1 0 011 1h3.5a1 1 0 011 1zM4.118 4L4 4.059V13a1 1 0 001 1h6a1 1 0 001-1V4.059L11.882 4zM2.5 3h11V2h-11z"/></svg></button>';
      html += '</div></div>';
    });
    itemsContainer.innerHTML = html;

    var total = items.reduce(function(s, i) { return s + (i.price * i.quantity); }, 0);
    var totalStr = (total / 100).toFixed(3).replace('.', ',') + ' DT';
    var count = getCount();
    var summary = dd.querySelector('.quote-dd-summary');
    if (summary) {
      summary.innerHTML = '<span>' + count + ' article' + (count > 1 ? 's' : '') + '</span><span class="subtotal">Sous-total: ' + totalStr + '</span>';
    }
  }

  function positionDropdown() {
    var dd = document.getElementById('quote-dropdown');
    if (!dd) return;
    var icon = null;
    if (window.innerWidth >= 992) {
      icon = document.querySelector('.header-icons .quote-icon-holder');
    } else {
      icon = document.querySelector('.m-quote-icon');
    }
    if (icon) {
      var rect = icon.getBoundingClientRect();
      dd.style.top = (rect.bottom + 5) + 'px';
      dd.style.right = Math.max(0, window.innerWidth - rect.right - 20) + 'px';
    } else {
      dd.style.top = '130px';
      dd.style.right = '0';
    }
  }

  function openDropdown() {
    var dd = document.getElementById('quote-dropdown');
    if (!dd) return;
    renderDropdown();
    positionDropdown();
    dd.style.display = 'block';
    dd.classList.add('show');
  }

  function closeDropdown() {
    var dd = document.getElementById('quote-dropdown');
    if (dd) { dd.classList.remove('show'); dd.style.display = 'none'; }
  }

  function toggleDropdown() {
    var dd = document.getElementById('quote-dropdown');
    if (dd && dd.classList.contains('show')) closeDropdown();
    else openDropdown();
  }

  // ---- Form Modal ----
  function openForm() {
    closeDropdown();
    var modal = document.getElementById('quote-form-modal');
    if (!modal) return;
    var items = getItems();
    if (items.length === 0) return;

    var tableBody = modal.querySelector('.quote-modal-items-body');
    if (tableBody) {
      var html = '';
      items.forEach(function(item, idx) {
        var imgSrc = item.image || '';
        var priceStr = (item.price / 100).toFixed(3).replace('.', ',');
        var lineTotal = ((item.price * item.quantity) / 100).toFixed(3).replace('.', ',');
        var variantDisplay = (item.variant_title && item.variant_title !== 'Default Title') ? '<br><small>' + item.variant_title + '</small>' : '';
        html += '<tr data-variant="' + item.variant_id + '">';
        html += '<td><img src="' + imgSrc + '" class="item-img" style="width:40px;height:40px;object-fit:cover;border-radius:3px;"></td>';
        html += '<td>' + item.title + variantDisplay + '</td>';
        html += '<td>' + (item.sku || '-') + '</td>';
        html += '<td><div class="quote-modal-qty-controls">';
        html += '<button type="button" onclick="QuoteManager.modalUpdateQty(\'' + item.variant_id + '\',-1)">-</button>';
        html += '<input type="number" min="1" value="' + item.quantity + '" onchange="QuoteManager.modalSetQty(\'' + item.variant_id + '\', this.value)" onclick="this.select()" class="quote-qty-input" style="width:70px;height:32px;text-align:center !important;padding:4px 0;margin:0 4px;border:1px solid #ccc;border-radius:4px;font-size:14px;line-height:24px;-moz-appearance:textfield;appearance:textfield;box-sizing:border-box;vertical-align:middle;" />';
        html += '<button type="button" onclick="QuoteManager.modalUpdateQty(\'' + item.variant_id + '\',1)">+</button>';
        html += '</div></td>';
        html += '<td>' + priceStr + '</td>';
        html += '<td>' + lineTotal + '</td>';
        html += '<td><button type="button" onclick="QuoteManager.modalRemove(\'' + item.variant_id + '\')" style="background:none;border:none;color:#e74c3c;cursor:pointer;font-size:16px;" title="Supprimer">&times;</button></td>';
        html += '</tr>';
      });
      var total = items.reduce(function(s, i) { return s + (i.price * i.quantity); }, 0);
      var totalStr = (total / 100).toFixed(3).replace('.', ',') + ' DT';
      html += '<tr style="font-weight:700;border-top:2px solid #eee;"><td colspan="5" style="text-align:right;padding-right:10px;">Sous-total produits :</td><td colspan="2">' + totalStr + '</td></tr>';
      tableBody.innerHTML = html;
    }

    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';

    var form = document.getElementById('quote-contact-form');
    if (form) form.reset();
    var success = modal.querySelector('.quote-success');
    var formBody = modal.querySelector('.quote-form-body');
    var itemsSummary = modal.querySelector('.quote-modal-items');
    var errorDiv = modal.querySelector('.quote-error');
    if (success) success.style.display = 'none';
    if (formBody) formBody.style.display = 'block';
    if (itemsSummary) itemsSummary.style.display = 'block';
    if (errorDiv) errorDiv.style.display = 'none';
    var deliverySummary = modal.querySelector('.quote-delivery-summary');
    if (deliverySummary) deliverySummary.style.display = '';
    updateQuoteTotal();
  }

  function closeForm() {
    var modal = document.getElementById('quote-form-modal');
    if (modal) modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  // ---- Submit Quote (Odoo API + FormSubmit fallback) ----
  function submitQuote(e) {
    if (e) e.preventDefault();
    var form = document.getElementById('quote-contact-form');
    if (!form) return;

    var submitBtn = form.querySelector('.quote-form-submit');
    var errorDiv = document.querySelector('.quote-error');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Envoi en cours...'; }
    if (errorDiv) errorDiv.style.display = 'none';

    // Gather form data
    var fname = form.querySelector('[name="fname"]').value.trim();
    var lname = form.querySelector('[name="lname"]').value.trim();
    var email = form.querySelector('[name="email"]').value.trim();
    var phone = form.querySelector('[name="phone"]').value.trim();
    var company = form.querySelector('[name="company"]') ? form.querySelector('[name="company"]').value.trim() : '';
    var address = form.querySelector('[name="address"]') ? form.querySelector('[name="address"]').value.trim() : '';
    var city = form.querySelector('[name="city"]') ? form.querySelector('[name="city"]').value.trim() : '';
    var zipcode = form.querySelector('[name="zipcode"]') ? form.querySelector('[name="zipcode"]').value.trim() : '';
    var tva = form.querySelector('[name="tva"]') ? form.querySelector('[name="tva"]').value.trim() : '';
    var payment = form.querySelector('[name="payment"]:checked') ? form.querySelector('[name="payment"]:checked').value : '';
    var notes = form.querySelector('[name="notes"]') ? form.querySelector('[name="notes"]').value.trim() : '';

    var items = getItems();
    var lines = items.map(function(item) {
      return { sku: item.sku, quantity: item.quantity };
    });

    // Odoo API payload
    var deliveryEl = document.querySelector('#quote-form-modal input[name="delivery"]:checked');
    var delivery_mode = deliveryEl ? deliveryEl.value : 'pickup';
    var has_timbre_fiscal = tva ? true : false;

    var payload = {
      customer: {
        first_name: fname,
        last_name: lname,
        email: email,
        phone: phone,
        company: company,
        street: address,
        city: city,
        zip: zipcode,
        vat: tva
      },
      payment_mode: payment,
      delivery_mode: delivery_mode,
      has_timbre_fiscal: has_timbre_fiscal,
      notes: notes,
      lines: lines
    };

    function showSuccess() {
      clearAll();
      var modal = document.getElementById('quote-form-modal');
      var success = modal.querySelector('.quote-success');
      var formBody = modal.querySelector('.quote-form-body');
      var itemsSummary = modal.querySelector('.quote-modal-items');
      if (success) success.style.display = 'block';
      if (formBody) formBody.style.display = 'none';
      if (itemsSummary) itemsSummary.style.display = 'none';
      var deliverySummary = modal.querySelector('.quote-delivery-summary');
      if (deliverySummary) deliverySummary.style.display = 'none';
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Envoyer la demande de devis'; }
    }

    function sendFormSubmitFallback() {
      var formSubmitData = new FormData();
      var mailLines = [];
      mailLines.push('DEMANDE DE DEVIS');
      mailLines.push('================');
      mailLines.push('');
      mailLines.push('Client: ' + fname + ' ' + lname);
      mailLines.push('Email: ' + email);
      mailLines.push('Telephone: ' + phone);
      if (company) mailLines.push('Societe: ' + company);
      if (city) mailLines.push('Ville: ' + city);
      if (address) mailLines.push('Adresse: ' + address);
      if (zipcode) mailLines.push('Code Postal: ' + zipcode);
      if (tva) mailLines.push('Matricule Fiscale: ' + tva);
      if (payment) mailLines.push('Mode de paiement: ' + payment);
      if (notes) mailLines.push('Notes: ' + notes);
      mailLines.push('');
      mailLines.push('PRODUITS:');
      mailLines.push('--------');
      items.forEach(function(item) {
        var lineTotal = ((item.price / 100) * item.quantity).toFixed(3);
        mailLines.push('- ' + item.title + ' (SKU: ' + (item.sku || 'N/A') + ') x ' + item.quantity + ' = ' + lineTotal + ' DT');
      });
      var grandTotal = items.reduce(function(sum, i) { return sum + (i.price / 100) * i.quantity; }, 0).toFixed(3);
      mailLines.push('');
      mailLines.push('TOTAL: ' + grandTotal + ' DT');

      formSubmitData.append('name', fname + ' ' + lname);
      formSubmitData.append('email', email);
      formSubmitData.append('phone', phone);
      formSubmitData.append('_subject', 'Demande de devis - ' + fname + ' ' + lname + (company ? ' (' + company + ')' : '') + ' - Total: ' + grandTotal + ' DT');
      formSubmitData.append('message', mailLines.join('\n'));
      formSubmitData.append('_captcha', 'false');
      formSubmitData.append('_template', 'table');

      fetch('https://formsubmit.co/ajax/contact@cothings.net', {
        method: 'POST',
        body: formSubmitData
      }).then(function() {
        console.log('Fallback: Quote sent via FormSubmit');
      }).catch(function(e) {
        console.warn('FormSubmit fallback also failed:', e);
      });
    }

    // Primary: Send to Odoo API
    fetch(ODOO_QUOTE_CONFIG.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': ODOO_QUOTE_CONFIG.apiKey
      },
      body: JSON.stringify(payload)
    }).then(function(res) {
      return res.json().then(function(data) {
        if (res.ok && data.success) {
          showSuccess();
        } else {
          // Odoo returned an error â€” fallback to email
          console.warn('Odoo quote API error:', data.error);
          sendFormSubmitFallback();
          showSuccess();
        }
      });
    }).catch(function(err) {
      // Network error â€” fallback to email
      console.error('Odoo quote API unreachable:', err);
      sendFormSubmitFallback();
      showSuccess();
    });
  }


  // ---- Live quote total (delivery + timbre fiscal) ----
  var DELIVERY_COST = 8.000;  // Aramex TTC
  var TF_COST = 1.000;        // Timbre Fiscal
  var FREE_THRESHOLD = 99;    // Free shipping threshold DT

  function updateQuoteTotal() {
    var modal = document.getElementById('quote-form-modal');
    if (!modal) return;
    var items = getItems();
    var productTotal = items.reduce(function(s, i) { return s + (i.price * i.quantity); }, 0) / 100;
    var isFreeShipping = productTotal >= FREE_THRESHOLD;

    // Delivery
    var deliveryEl = modal.querySelector('input[name="delivery"]:checked');
    var deliveryMode = deliveryEl ? deliveryEl.value : '';
    var deliveryCost = 0;
    if (deliveryMode === 'aramex' && !isFreeShipping) {
      deliveryCost = DELIVERY_COST;
    }

    // Free shipping note
    var note = modal.querySelector('.quote-delivery-note');
    if (note) note.style.display = isFreeShipping ? 'block' : 'none';
    var costLabel = modal.querySelector('.delivery-cost-label');
    if (costLabel) costLabel.textContent = isFreeShipping ? 'Gratuit' : '8,000 DT';

    // Delivery row
    var deliveryRow = modal.querySelector('.quote-delivery-row');
    if (deliveryRow) {
      deliveryRow.style.display = deliveryMode === 'aramex' ? '' : 'none';
      var dv = modal.querySelector('.quote-delivery-value');
      if (dv) dv.textContent = isFreeShipping ? 'Gratuit' : '8,000 DT';
    }

    // Timbre Fiscal
    var tvaInput = document.getElementById('quote-tva-input');
    var hasTF = tvaInput && tvaInput.value.trim().length > 0;
    var tfCost = hasTF ? TF_COST : 0;
    var tfRow = modal.querySelector('.quote-tf-row');
    if (tfRow) tfRow.style.display = hasTF ? '' : 'none';

    // Subtotal
    var subtotalEl = modal.querySelector('.quote-subtotal-value');
    if (subtotalEl) subtotalEl.textContent = productTotal.toFixed(3).replace('.', ',') + ' DT';

    // Grand total
    var grandTotal = productTotal + deliveryCost + tfCost;
    var gtEl = modal.querySelector('.quote-grand-total-value');
    if (gtEl) gtEl.textContent = grandTotal.toFixed(3).replace('.', ',') + ' DT';
  }

  // ---- Init ----
  function init() {
    updateBadge();

    if (localStorage.getItem('cothings_quote_submitted') === 'true') {
      localStorage.removeItem('cothings_quote_submitted');
      var toast = document.getElementById('quote-toast');
      if (toast) {
        toast.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M9 12l2 2 4-4"/></svg> <span><b>Demande de devis envoy\u00e9e avec succ\u00e8s!</b><br>Nous vous contacterons dans les plus brefs d\u00e9lais.</span>';
        toast.style.display = 'flex';
        toast.classList.remove('hide');
        clearTimeout(toast._timer);
        toast._timer = setTimeout(function() {
          toast.classList.add('hide');
          setTimeout(function() { toast.style.display = 'none'; }, 300);
        }, 6000);
      }
    }

    document.querySelectorAll('.quote-toggle').forEach(function(el) {
      el.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); toggleDropdown(); });
    });

    var hoverTimer = null;
    function isFormModalOpen() {
      var modal = document.getElementById('quote-form-modal');
      return modal && modal.style.display !== 'none';
    }
    function closeCartDropdown() {
      var cartHolder = document.querySelector('.top-cart-holder.hover-dropdown');
      if (cartHolder) {
        cartHolder.classList.remove('open', 'show');
        var evt = new MouseEvent('mouseleave', { bubbles: true, cancelable: true });
        cartHolder.dispatchEvent(evt);
      }
    }
    document.querySelectorAll('.quote-icon-holder').forEach(function(holder) {
      holder.addEventListener('mouseenter', function() {
        if (isFormModalOpen()) return;
        closeCartDropdown();
        clearTimeout(hoverTimer);
        renderDropdown();
        positionDropdown();
        var dd = document.getElementById('quote-dropdown');
        if (dd) { dd.style.display = 'block'; dd.classList.add('show'); }
      });
      holder.addEventListener('mouseleave', function() {
        hoverTimer = setTimeout(function() {
          var dd = document.getElementById('quote-dropdown');
          if (dd && !dd.matches(':hover')) { dd.classList.remove('show'); dd.style.display = 'none'; }
        }, 200);
      });
    });
    var ddEl = document.getElementById('quote-dropdown');
    if (ddEl) {
      ddEl.addEventListener('mouseenter', function() { clearTimeout(hoverTimer); });
      ddEl.addEventListener('mouseleave', function() {
        hoverTimer = setTimeout(function() { ddEl.classList.remove('show'); ddEl.style.display = 'none'; }, 200);
      });
    }

    var submitBtn = document.querySelector('.quote-dd-submit');
    if (submitBtn) submitBtn.addEventListener('click', openForm);

    var clearBtn = document.querySelector('.quote-dd-clear');
    if (clearBtn) clearBtn.addEventListener('click', function() { if (confirm('Vider la liste de devis?')) clearAll(); });

    var closeBtn = document.querySelector('.quote-dd-close');
    if (closeBtn) closeBtn.addEventListener('click', closeDropdown);

    document.querySelectorAll('.quote-modal-close, .quote-modal-overlay').forEach(function(el) {
      el.addEventListener('click', closeForm);
    });

    var form = document.getElementById('quote-contact-form');
    if (form) form.addEventListener('submit', submitQuote);

    // Live total updates — delivery radio + TVA input
    document.querySelectorAll('input[name="delivery"]').forEach(function(r) {
      r.addEventListener('change', updateQuoteTotal);
    });
    var tvaInput = document.getElementById('quote-tva-input');
    if (tvaInput) tvaInput.addEventListener('input', updateQuoteTotal);

    var quoteBtn = document.querySelector('.btn-quote');
    if (quoteBtn) quoteBtn.addEventListener('click', addFromProductPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function modalUpdateQty(variantId, delta) {
    var items = getItems();
    var item = items.find(function(i) { return i.variant_id == variantId; });
    if (item) {
      item.quantity = Math.max(1, item.quantity + delta);
      saveItems(items);
      updateBadge();
      openForm();
    }
  }

  function modalSetQty(variantId, qty) {
    var items = getItems();
    var item = items.find(function(i) { return i.variant_id == variantId; });
    var n = parseInt(qty, 10);
    if (!n || n < 1) n = 1;
    if (item && item.quantity !== n) {
      item.quantity = n;
      saveItems(items);
      updateBadge();
      openForm();
    }
  }

  function modalRemove(variantId) {
    removeItem(variantId);
    var items = getItems();
    if (items.length === 0) {
      closeForm();
    } else {
      openForm();
    }
  }

  return {
    addItem: addItem,
    removeItem: removeItem,
    updateQuantity: updateQuantity,
    clearAll: clearAll,
    getCount: getCount,
    addFromProductPage: addFromProductPage,
    openDropdown: openDropdown,
    closeDropdown: closeDropdown,
    openForm: openForm,
    closeForm: closeForm,
    toggleDropdown: toggleDropdown,
    modalUpdateQty: modalUpdateQty,
    modalSetQty: modalSetQty,
    modalRemove: modalRemove
  };
})();
